import { BaseUserProfile, IMarketingAnalyticsProvider } from 'fitbeat.models';

interface IGoogleAnalyticsConfig {
  googleAnalyticsMeasurementId?: string;
  googleAnalyticsAPISecret?: string;
}

export class GoogleAnalyticsProvider implements IMarketingAnalyticsProvider {
  public readonly name = 'Google Analytics';

  constructor(private config: IGoogleAnalyticsConfig, private logger: any, private fetch: any) {}

  public async logEvent(name: string, userProfile: BaseUserProfile, params?: any): Promise<void> {
    this.logger.info(`log event ${name} in google analytics`);
    const measurementId = this.config.googleAnalyticsMeasurementId;
    const apiSecret = this.config.googleAnalyticsAPISecret;

    const envConfigured = !!(measurementId && apiSecret);
    if (!envConfigured) {
      return;
    }

    const url = 'https://www.google-analytics.com/mp/collect';
    await this.fetch(`${url}?measurement_id=${measurementId}&api_secret=${apiSecret}`, {
      method: 'POST',
      body: JSON.stringify({
        client_id: 'server',
        user_id: userProfile.uid,
        events: [{
          name,
          params,
        }],
      }),
    });
  }

  public async syncCustomer(userProfile: BaseUserProfile): Promise<void> {
    this.logger.debug(`syncCustomer not implemented on the google analytics provider`);
  }
}
